// src/components/DynamicSelectFetcher.tsx
import React, { useMemo } from "react";
import { Select, Spin } from "antd";
import useInfiniteSelectOptions from "../../hooks/useInfiniteSelectOptions";

interface DynamicSelectFetcherProps {
  fieldConfig: any; // Sesuaikan tipe ini dengan definisi fieldConfig Anda
  value?: any; // Nilai field saat ini
  onChange: (value: string | number | null) => void; // Handler untuk perubahan nilai
  placeholder?: string;
}

const DynamicSelectFetcher: React.FC<DynamicSelectFetcherProps> = ({
  fieldConfig,
  value,
  onChange,
  placeholder,
  ...rest
}) => {
  const selectProps = useInfiniteSelectOptions(
    fieldConfig.queryKeyBase,
    fieldConfig.apiFn,
    fieldConfig.idField || "id",
    fieldConfig.labelField || "name"
  );

  const options = useMemo(() => selectProps.options, [selectProps.options]);

  return (
    <Select
      // name={name}
      {...rest}
      value={options?.find((opt: any) => opt?.value?.toString() === value)}
      onChange={(selectedValue) => {
        onChange(selectedValue); // Panggil onChange yang disediakan
      }}
      className="select d-flex"
      style={{ width: "100%" }}
      placeholder={placeholder}
      showSearch
      filterOption={false}
      onSearch={selectProps.handleSearch}
      onPopupScroll={selectProps.handlePopupScroll}
      loading={selectProps.isLoading}
      notFoundContent={
        selectProps.isLoading ? <Spin size="small" /> : "Tidak ditemukan"
      }
      options={options}
    />
  );
};

export default DynamicSelectFetcher;
